import React from 'react';
import ProductHorizontal from '../ProductHorizontal';

const NewArrivals = ({ new_arivals, toggleQuickViewModal }) => {
    if (new_arivals.length === 0) return null;

    return (
        <div className="holder">
            <div className="container">
                <div className="title-wrap title-md">
                    <h2 className="h2-style" style={{
                        color: "red !important",
                        fontWeight: "700"
                    }}>NEW ARRIVALS</h2>
                </div>
                <div className="prd-grid-wrap position-relative">
                    <div className="prd-grid data-to-show-3 data-to-show-lg-3 data-to-show-md-2 data-to-show-sm-2 data-to-show-xs-2 js-category-grid justify-content-start">
                        {new_arivals.map((el) => (
                            <ProductHorizontal
                                key={el.id}
                                product_data={el}
                                toggleQuickViewModal={toggleQuickViewModal}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewArrivals;
